// extracted by mini-css-extract-plugin
export default {"aboutPage":"AboutPage_aboutPage__E58Ao","title":"AboutPage_title__6cOsI","subtitle":"AboutPage_subtitle__3slso"};